exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".feather-16[data-v-6c4ea116]{width:16px;height:16px;cursor:pointer}", ""]);

// exports
